import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { PasslyButton } from '@app/components';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        addButton: {
            padding: 2,
            minWidth: 0
        }
    }),
);

export const AddElement = (props: any) => {

    const classes = useStyles();

    return (
        <PasslyButton
            id='addElement'
            color='primary'
            variant='contained'
            className={classes.addButton}
            {...props}
        >
            <Add />
        </PasslyButton>
    );
};
